import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getMccCodes = async (token) => {
  const url = 'mcc_codes'
  const data = await apiGet({ url, token })
  return data
}

export default function useMccCodes({ options } = {}) {
  const token = useContext(AuthContext)
  const queryFn = () => getMccCodes(token)
  const queryKey = 'mcc_codes'

  return useQuery(queryKey, queryFn, {
    staleTime: Infinity,
    ...options
  })
}
